import React from 'react';
import { Html } from '../components/ui/hero-futuristic';

export const Landing: React.FC = () => {
  return <Html />;
};
